export default __webpack_public_path__ + "static/media/Moluk-Boi-2.d343043d.jpg";